module.exports = __webpack_public_path__ + "img/ornament_rotator.678e56f5.svg";